/**
 * Connector Events
 *
 * Custom event bridge for chat connector cards (GitHub App, CLI providers,
 * Space repo links). Mirrors signposting location + private vault: after the
 * user finishes auth, chat auto-sends a non-secret ack so Losi continues with
 * knowledge that the connector is connected.
 */

import {
  LOSI_CONNECTOR_LABELS,
  type LosiConnectorType
} from '@/lib/connectors/types'

// --------------

export const CONNECTOR_CONNECTED_EVENT = 'losi:connector-connected'

// --------------

export type ConnectorConnectedEventDetail = {
  chatId: string
  connector: LosiConnectorType
  status: 'connected' | 'declined'
  /** Optional human label for the ack message. */
  label?: string
  /** Optional Space id when the connector was a repo link. */
  spaceId?: string
}

// --------------

export function connectorAckMessage(detail: ConnectorConnectedEventDetail): string {
  const label = detail.label || LOSI_CONNECTOR_LABELS[detail.connector]

  if (detail.status === 'declined') {
    return `Connector request declined for ${label}.`
  }

  return `${label} is now connected. Continue with the coding task.`
}

// --------------

export function emitConnectorConnected(detail: ConnectorConnectedEventDetail) {
  window.dispatchEvent(new CustomEvent(CONNECTOR_CONNECTED_EVENT, { detail }))
}
